module.exports = __webpack_public_path__ + "img/3C.fede85e4.svg";